import { mapGetters, mapActions } from 'vuex';
import marketChangePrice from '@/components/market/market-change-price/market-change-price.vue';
import { isMarketSingle, marketUserGainLoss } from '@/utils/helpers';

export default {
  components: {
    marketChangePrice,
  },
  props: {
    market: {
      type: Object,
      required: true,
    },
    theme: {
      type: String,
      required: false,
      default: '',
    },
    showLabels: {
      type: Boolean,
      default: true,
    },
    showMarketLink: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile']),
    ...mapGetters('user', ['isLoggedIn']),
    userGainLoss() {
      return marketUserGainLoss(this.market);
    },
    isAllPayoutsAvailable() {
      return !isMarketSingle(this.market);
    },
    gainIndicatorClassModifier() {
      return {
        'market-payout__gain': true,
        'market-payout__going-down': !this.userGainLoss,
      };
    },
    classModifiers() {
      return {
        'market-payout': true,
        [`market-payout--${this.theme}`]: this.theme,
      };
    },
    gainLossLabel() {
      return this.userGainLoss >= 0 ? 'Gain' : 'Loss';
    },
  },
  methods: {
    ...mapActions('popup', ['setGenericPopup']),
    allPayouts() {
      // because there is no routing for modals
      this.setGenericPopup({
        name: 'potential-payouts',
        options: {
          market: this.market,
        },
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-payout/market-payout.js